import { Component } from '@angular/core';

@Component({

  selector: 'app-footer',

  templateUrl: './footer.component.html',

  styleUrls: ['./footer.component.css']

})

export class FooterComponent {

  lst_Contact = [
    {
      title: 'شرکت آب و فاضلاب استان اصفهان',
      description: ' اصفهان -خیابان هزار جریب, خیابان جابر ابن حیان, شرکت آب و فاضلاب استان اصفهان -کد پستی : ۸۱۶۸۹۳۶۵۵۶ - تلفن تماس : 35132000 - (031)'
    },
    {
      title: 'پشتیبانی - شرکت رایان اندیشه نصر',
      description: 'تهران،نارمک،بزرگراه شهید سلیمانی، بعد از چهارراه سرسبز پلاک ۶۴۰ واحد ۸ تلفن‌های تماس : 09138070511 , 2 - 77273160 - (021)'
    }
    
  ]

}
